import styled from "styled-components";
import { Box, SpanStyled, TextStyled } from "../../styled/Elements";
import { useTranslation } from "react-i18next";



const ViewDetailBar = (props) => {
	const { t } = useTranslation();
	return (
		<TableContentColumn>
                <Box className="column-label">{t(props.title)}</Box>
                <Box className="column-value" style={["ContactNo", "phone"].includes(props.title) ? {direction: "ltr"}: {}}>{props.value}</Box>
        </TableContentColumn>
	);
};

const TableContentColumn = styled.div`
    
    margin-right: 20px;
    width: 100%;
  
  .column-label {
    color: var(--text);
    font-weight: bold;
    margin-bottom: 5px;
    text-wrap: nowrap;
  }

  .column-value {
    color: var(--themeColor2);
    font-weight: bold;
    white-space: nowrap;
  }
`;

export default ViewDetailBar;
